import { LogoutAction } from '@/redux/actions/authActions';
import { cleanUp, isLogged } from '@/redux/reducers/autoLoggedOut';
import { AssessmentControlsSkeleton } from '@/shared/components/Skeleton/AssessmentControlsSkeleton';
import { SkeletonForRightSideContent } from '@/shared/components/Skeleton/SkeletonForRightSideContent';
import { TicketsSkeletonComponent } from '@/shared/components/Skeleton/TicketsSkeletonComponent';
import { VirtualMachinesSkeleton } from '@/shared/components/Skeleton/VirtualMachinesSkeleton';
import { paddingLeft } from '@/utils/directions';
import { colorBackgroundBody } from '@/utils/palette';
import React, { Suspense, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { setPermissionArray } from '../../../redux/reducers/rbacReducer';
import { getLocalStorageData } from '../../../utils/LocalStorage';
import { ResetIndexedDb } from '../../../utils/ResetIndexedDb';

const getSkeletonComponent = (pathname) => {
  const pathSegments = pathname.split('/').filter(Boolean);
  if (pathSegments.length <= 1) {
    console.log('pathSegments', pathSegments);
    return <SkeletonForRightSideContent />;
  }
  const [basePath, dynamicSegment] = pathSegments;

  if (dynamicSegment) {
    switch (basePath) {
      case 'assessments':
        return <AssessmentControlsSkeleton isLoading={true} />;
      case 'tickets':
        return <TicketsSkeletonComponent isLoading={true} />;
      case 'alltickets':
        return <TicketsSkeletonComponent isLoading={true} />;
      case 'allprojects':
        return <TicketsSkeletonComponent isLoading={true} />;
      case 'all_projects_tickets':
        return <TicketsSkeletonComponent isLoading={true} />;
      case 'tickets_dashboard':
        return <TicketsSkeletonComponent isLoading={true} />;
      case 'projects':
        return <TicketsSkeletonComponent isLoading={true} />;
      case 'virtual_machines':
        return (
          <VirtualMachinesSkeleton
            isLoading={true}
            detailMode={true}
          />
        );
      default:
        return <SkeletonForRightSideContent />;
    }
  }

  return <SkeletonForRightSideContent />;
};

const MainContainerWrapper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOnboarded, setIsOnboarded] = useState(false);
  const collapse = useSelector((state) => state?.sidebar?.collapse);
  const { currentUser } = useSelector((state) => state?.auth);
  const customerOnboarded = useSelector((state) => state?.auth?.currentUser?.customerOnboarded);
  const { username } = currentUser;

  useEffect(() => {
    if (customerOnboarded) {
      setIsOnboarded(customerOnboarded);
    }
  }, [customerOnboarded]);
  useEffect(() => {
    isLogged();
    const interval = setInterval(() => {
      const expiredTime = getLocalStorageData('logoutTime');
      if (expiredTime < Date.now()) {
        dispatch(setPermissionArray([]));
        ResetIndexedDb('MainWrapper');
        localStorage.removeItem('_expiredTime');
        // localforage.dropInstance({ name: 'STN', storeName: 'stnOne' });
        window.indexedDB.deleteDatabase('STN');
        dispatch(LogoutAction(username, navigate));
        localStorage.removeItem('currentCustomerID');
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
        navigate('/login');
        clearInterval(interval);
      }
    }, 10000);

    return () => {
      clearInterval(interval);
      cleanUp();
    };
  }, []);

  return (
    <>
      {isOnboarded == false ? (
        <Suspense fallback={getSkeletonComponent(location.pathname)}>
          <ContainerWrap
            $collapse={collapse}
            $customerOnboarded={customerOnboarded}
          >
            <Outlet />
          </ContainerWrap>
        </Suspense>
      ) : (
        <Suspense fallback={getSkeletonComponent(location.pathname)}>
          <ContainerWrap2 $collapse={collapse}>
            <Outlet />
          </ContainerWrap2>
        </Suspense>
      )}
    </>
  );
};

export default MainContainerWrapper;

const LoadingWrap = styled.div`
  display: flex;
  justify-content: center;
  font-size: 20px;
  align-items: center;
  height: 100vh;
`;

const MainContainer = styled.div`
  height: 90vh;
  background: ${colorBackgroundBody};
  // overflow-y: auto;
`;

const ContainerWrap2 = styled.div`
  padding-top: 0px;
  min-height: 100vh;
  /* border:3px solid #0f0; */
  transition: padding-left 0.3s;
  ${paddingLeft}: 0;
  background: ${colorBackgroundBody};
  overflow-y: auto;
  @media screen and (min-width: 576px) {
    padding-left: ${({ $collapse }) => ($collapse ? '60px' : '250px')};
  }
  @media screen and (max-width: 576px) {
    padding-top: 20px;
  }
`;

const ContainerWrap = styled(Container)`
  padding-top: 0px;
  min-height: 100vh;
  /* border:3px solid #0f0; */
  transition: padding-left 0.3s;
  ${paddingLeft}: 0;
  background: ${colorBackgroundBody};
  padding: 20px 15px;
`;
